module.exports = __webpack_public_path__ + "img/testImage8.193463c1.193463c1.png";